var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import AreaRow from '@/components/area-row/AreaRow';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Subject } from '@/models/Subject';
import { Project } from '@/models/Project';
import ErrorHandler from '@/support/ErrorHandler';
let CreateProjectDialog = class CreateProjectDialog extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.currentStep = 1;
        this.isLoading = false;
        this.project = new Project();
        this.areas = [];
        this.selectedSubjects = [];
        this.iterationKey = 1;
        this.filters = {
            periods: [],
            levels: [],
        };
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.getSubjects();
        this.isLoading = false;
    }
    // #endregion
    // #region Class methods
    deleteSelectedSubject(index) {
        this.selectedSubjects.splice(index, 1);
    }
    close() {
        this.reset();
        this.$emit('input', false);
    }
    reset() {
        this.project = new Project();
        this.$store.dispatch('selectedChanged', []);
        this.selectedSubjects = [];
        this.currentStep = 1;
        this.isLoading = false;
    }
    filterCurriculum() {
        // console.log('filterCurriculum');
        this.selectedSubjects = this.$store.state.selected || [];
        this.selectedSubjects.forEach((selectedSubject) => {
            if (!selectedSubject.parent) {
                return;
            }
            this.$store.state.curriculum.subjects.forEach((area) => {
                if (!area.children) {
                    return;
                }
                const topics = area.children.filter((subject) => {
                    return subject.id === selectedSubject.parent.id;
                });
                if (topics.length) {
                    selectedSubject.parent.parent = area;
                }
            });
        });
    }
    // #endregion
    // #region Async methods
    async getSubjects() {
        const extendedFilters = {};
        Object.keys(this.filters).forEach((key) => {
            if (this.filters[key] === null || this.filters[key].length === 0) {
                return;
            }
            extendedFilters[key] = this.filters[key];
        });
        try {
            this.areas = await new Subject()
                .filter(extendedFilters)
                .limit(100)
                .include('children')
                .all();
            this.iterationKey += 1;
        }
        catch (error) {
        }
    }
    async onClickCreate() {
        this.isLoading = true;
        const payload = this.project.clone();
        payload.subjects = this.selectedSubjects
            .map((subject) => subject.id);
        const project = await payload
            .create()
            .catch(((error) => { ErrorHandler.network(error); }));
        if (project) {
            this.$emit('project:created');
            this.close();
        }
    }
    // #endregion
    // #region Getters & Setters
    // #endregion
    // #region @Watchers
    currentStepChanged() {
        if (this.currentStep === 3) {
            this.filterCurriculum();
        }
    }
    levelFilterChange() {
        this.getSubjects();
    }
};
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CreateProjectDialog.prototype, "currentStepChanged", null);
__decorate([
    Watch('filters', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CreateProjectDialog.prototype, "levelFilterChange", null);
CreateProjectDialog = __decorate([
    Component({
        components: {
            AreaRow,
            SelectFilter,
        },
    })
], CreateProjectDialog);
export default CreateProjectDialog;
